<script>
  import timezones from "./timezones"
  import { createEventDispatcher } from "svelte"

  export let user
  export let open = true
  const dispatch = createEventDispatcher()

  const clear = () => {
    user = {
      name: "", email: "",
      tz: "", availability: {
        week: [], weekend: []
      }
    }
  }

  const save = () => {
    dispatch("save", user)
    clear()
  }

  const close = () => open = false

  const saveAndClose = () => save() + close()

  if (!user) clear()
</script>

{#if open}
  <div class="outer" on:click|self={close}>
    <div class="inner">
      <input class=input bind:value={user.name} placeholder=Name />
      <input class=input bind:value={user.email} placeholder=Email type=email />
      <select class="input" bind:value={user.tz}>
        <option value="" disabled>Select timezone</option>
        {#each timezones as timezone}
          <option value={timezone.value}>{timezone.label}</option>
        {/each}
      </select>

      <h3>Availability during the week</h3>
      <label><input bind:group={user.availability.week} type=checkbox name=week value=morning /> Morning</label>
      <label><input bind:group={user.availability.week} type=checkbox name=week value=afternoon /> Afternoon</label>
      <label><input bind:group={user.availability.week} type=checkbox name=week value=evening /> Evening</label>

      <h3>Availability during the weekend</h3>
      <label><input bind:group={user.availability.weekend} type=checkbox name=weekend value=morning /> Morning</label>
      <label><input bind:group={user.availability.weekend} type=checkbox name=weekend value=afternoon /> Afternoon</label>
      <label><input bind:group={user.availability.weekend} type=checkbox name=weekend value=evening /> Evening</label>

      <br><br>
      <div class=btns>
        <button on:click={close}>Cancel</button>
        <button on:click={saveAndClose}>Save and close</button>
        <button on:click={save}>Save and add another</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .outer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.2);
  }

  .inner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 400px;
    height: 440px;
    padding: 1rem;
    margin: auto;
    background: white;
  }

  .btns {
    display: flex;
    justify-content: space-around;
  }

  .input {
    display: block;
    width: 400px;
  }
</style>